import React from 'react';
import Join from './Join';
import Layout from '../../components/Layout';
import getUser from "../../utils/getUser";
import Cookies from "js-cookie";
import history from "../../history";

async function action({ params, fetch }) {
  if (getUser()) {
    alert("You're already authorized. This invite is for new users :)");
    return history.push('/');
  }

  const resp = await fetch('/graphql', {
    body: JSON.stringify({
      query: `{profile(userId:"${params.userId}"){displayName}}`
    }),
  });

  const data = await resp.json();
  const displayName = data.data && data.data.profile && data.data.profile.displayName ? data.data.profile.displayName : '';

  // Устанавливаем, кто пригласил, чтобы после авторизации выставить ему статус joined
  Cookies.set('joinedBy', params.userId);

  return {
    title: 'New Tab Studio',
    chunks: ['join'],
    component: (
      <Layout>
        <Join fetch={fetch} userName={displayName} />
      </Layout>
    ),
  };
}

export default action;
